import { getHasGlobalFilterDurationChangedFromDefault } from '@modules/dashboard/helpers';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { useGetQuantifyStateFromAnalysisStore } from '@modules/quantify/hooks';

export const useIsDashboardDurationSupportedForQuantify = () => {
  const globalFilterDuration = useDashboardStore(({ query }) => query.duration);
  const parsedMetadata = useGetQuantifyStateFromAnalysisStore();

  const hasGlobalFilterDurationChangedFromDefault =
    getHasGlobalFilterDurationChangedFromDefault(globalFilterDuration);

  const compareQueryType = (() => {
    if (parsedMetadata?.query?.compareQuery?.whereClause) {
      return 'whereClause';
    }

    if (parsedMetadata?.query?.compareQuery?.previousPeriod) {
      return 'offset';
    }

    if (parsedMetadata?.query?.compareQuery?.timerange) {
      return 'timerange';
    }
  })();

  if (
    !compareQueryType ||
    compareQueryType === 'whereClause' ||
    !hasGlobalFilterDurationChangedFromDefault
  ) {
    return true;
  }

  const isLastGlobalFilterDuration = globalFilterDuration?.type === 'last';

  if (compareQueryType === 'offset' && !isLastGlobalFilterDuration) {
    return false;
  }

  const isLastOrSinceCompareDuration =
    compareQueryType === 'timerange' &&
    parsedMetadata?.query?.compareQuery?.timerange?.relative;

  if (
    compareQueryType === 'timerange' &&
    isLastOrSinceCompareDuration &&
    !isLastGlobalFilterDuration
  ) {
    return false;
  }

  return true;
};
